"use strict"

// Х о н е й п о т

$(document).on("turbolinks:load", function() {
  window.activate_individual_surname()
})


window.activate_individual_surname = function() {
  const honeypots = $(".individual_surname")

  if (honeypots.length == 0) {
    return null
  }

  honeypots.each(function(index, element) {
    const honeypot = $(element)

    // Проверяем, не вставили ли мы уже поле, потому что:
    // remote: true, !valid? => format.js, j render partial: + activate_individual_surname()
    if (honeypot.next("input[name='individualsurname']").length > 0) {
      return;
    }

    const server_time = honeypot.data("individual_surname")

    const $jsField = $("<input>", {
      type: "hidden",
      name: "individualsurname",
      value: server_time
    })

    honeypot.after($jsField)
  })
}
